import classNames from 'classnames';
import React from 'react';
import _ from 'underscore';
import { string, shape } from 'prop-types';
import Breadcrumbs from './Breadcrumbs';
import Illustration from './Illustration';
import Logo from './Logo';

import styles from '../../styles/header.module.styl';

const Header = ({ title, pageId, groupId, subPage, question, group, logo }) => {
  const headerClassess = classNames(styles.header, {
    [styles.headerLow]: group,
    [styles.headerHigh]: !group,
  });

  return (
    <div className={headerClassess}>
      <Logo />
      {!group ? (
        <div>
          <div className={styles.overlay}>
            <div className={styles.title}>{title}</div>
            <div className={styles.separator} />
            <div className={styles.question}>{question}</div>
          </div>
          <div className={styles.illustrationContainer}>
            <Illustration logo={logo} />
          </div>
        </div>
      ) : (
        <div>
          <div className={styles.inlineIllustration}>
            <div className={styles.subPageQuestion}>{group.title}</div>
            <div className={styles.illustrationContainer}>
              <Illustration logo={logo} />
            </div>
          </div>
          <Breadcrumbs pageId={pageId} groupName={groupId} activeSubPageId={subPage} />
        </div>
      )}
    </div>
  );
};

Header.propTypes = {
  pageId: string,
  groupId: string,
  subPage: string,
  question: string,
  group: shape({
    name: string,
    title: string,
  }),
  title: string,
};

Header.defaultProps = {
  pageId: '',
  groupId: '',
  subPage: '',
  question: '',
  title: '',
  group: null,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/Header.js